import { Link } from "react-router-dom";
import { quickCategories } from "@/mocks/categories";

export default function CategoryQuick() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16" aria-label="电影分类快捷入口">
      <div className="flex items-end justify-between gap-4">
        <div>
          <p className="font-label text-sm font-medium text-accent-600">快速导航</p>
          <h2 className="mt-1.5 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            电影分类快捷入口
          </h2>
        </div>
        <Link
          to="/category"
          className="hidden whitespace-nowrap font-label text-sm text-primary-600 transition-colors hover:text-primary-700 cursor-pointer md:inline-flex md:items-center md:gap-1"
        >
          全部分类
          <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>

      <div className="mt-7 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {quickCategories.map((item) => (
          <Link
            key={item.name}
            to={`/category?genre=${encodeURIComponent(item.name)}`}
            className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-50 p-4 transition-colors duration-300 hover:border-accent-300 hover:bg-accent-50 cursor-pointer md:p-5"
          >
            <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-100 text-primary-600 transition-colors group-hover:bg-accent-100 group-hover:text-accent-700">
              <i className={`${item.icon} text-2xl`} aria-hidden="true"></i>
            </span>
            <div>
              <h3 className="font-heading text-base font-semibold text-foreground-950">{item.name}片</h3>
              <p className="mt-1 text-xs leading-relaxed text-foreground-500">{item.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}